import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
declare var $: any;
@Component({
  selector: 'app-editspeciesmanagement',
  templateUrl: './editspeciesmanagement.component.html',
  styleUrls: ['./editspeciesmanagement.component.css']
})
export class EditspeciesmanagementComponent implements OnInit {
  returnUrl= "/dashboard/speciesmanagement";
  getspecieseditApi: string;
  putspecieseditApi:any;
  loginresponse:any;
  userrole:any;
  age_group_getval=[];
  editSpeciesFormValue:any;
  addUrl:any;
  farm_userrole:any;
  upperlimit2:any='';
  upperlimit:any='';
  upperlimit1:any='';
  isDone:any;
  statuschange:any;
  myProperty = 0;
  isDisabled:boolean=false;
  getlistApi:any;
  getfarmsListData:any;
  showdiv:any;
  dropdownsize:boolean=false;
  registerForm:any;
  isLoading:boolean =false;
  agegroupname4:any;
  tnagid1:any;
  tnagid2:any;
  tnagid3:any;
  tnagid4:any;
  cby_mby:any;
  speciesloadid:any='';
  resultcond:any;
  arrayval:any=[];
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit() {
    this.isLoading=true;
    this.dropdownsize=true;
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.farm_userrole){
        $("#farmname").attr("disabled","disabled")
    }
    /*this.getlistApi= "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {

              this.getfarmsListData = res.data;

       
        console.log(this.getfarmsListData);
        setTimeout(() => {
          $(function() {  
                  $('#farmname').multiselect({
                    buttonText: function (options) {
                      if (options.length == 0) {
                          return ' None selected ';
                      } else {
                          var selected = 0;
                          options.each(function () {
                              selected += 1;
                          });
                          return selected +  ' Selected ';
                      }
                  },
                         
                             includeSelectAllOption: true,
                             enableFiltering: true,
                             enableCaseInsensitiveFiltering: true,
                             filterPlaceholder: 'Search for something...',
                             onChange:function(option, checked, select) {
                             this.selectedmultidata= $('#farmname').val();
                             console.log(  this.selectedmultidata);
                            
                           }
                           
                         }); 
                 });
          
                  this.isLoading =false;
             
        }, );
   
 
      })*/
    $('.selectpicker').selectpicker('refresh');
    let speaciesId = sessionStorage.getItem('speciesId');
    this.getspecieseditApi= "/species/"+ speaciesId;
    this.putspecieseditApi= "/species/"+ speaciesId;
    (await this.commonService.getApi(this.getspecieseditApi)).subscribe(
      async (res:any) => {
        var getfarmid=res.data.farm_id.split(",");
        this.resultcond=getfarmid.length;
      this.speciesloadid =getfarmid.map((num)=>{
          return {farmloadid:num};
        });
     
  
  
        var speciesid= res.data.id;
        //---------------http://18.116.99.161/api/farms/checkfarm_status/list?species_id=404
    ///////////////////code need to change here...................
    this.getlistApi="/farms/checkfarm_status/list?species_id="+speciesid;
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {  

        setTimeout(() => {
          this.getfarmsListData = res.data;  
          $(function() {  
                  $('#farmname').multiselect({
                    buttonText: function (options) {
                      if (options.length == 0) {
                          return ' None selected ';
                      } else {
                          var selected = 0;
                          options.each(function () {
                              selected += 1;
                          });
                          return selected +  ' Selected ';
                      }
                  },
                         
                             includeSelectAllOption: true,
                             enableFiltering: true,
                             enableCaseInsensitiveFiltering: true,
                             filterPlaceholder: 'Search for something...',
                             onChange:function(option, checked, select) {
                             this.selectedmultidata= $('#farmname').val();
                             console.log(  this.selectedmultidata);
                            
                           }
                           
                         }); 
                 });
                 this.isLoading=false;
        },);
      })
///////////////////code need to change here...................
        this.arrayval=res.data.age_group.map((ele)=>{
         var splitedrange= ele.tnag_time_range.split('-');
         var lowerlimit=splitedrange[0];
         var upperlimit=splitedrange[1];
          return {"tnag_name":ele.tnag_name,"lowerlimit":lowerlimit,"upperlimit":upperlimit,"tnag_id":ele.tnag_id}
        })
        this.agegroupname4=this.arrayval.length;
        console.log(this.agegroupname4)
        console.log(this.arrayval);
       
     /* var getfarmid=res.data.farm_id.split(",");
      console.log(getfarmid);
          setTimeout(function () {  
            for(var i=0;i<getfarmid.length;i++){
            var optionVal = getfarmid[i];
            console.log(optionVal);
            $("#farmname").find("option[value="+optionVal+"]").prop("selected", "selected");
         // if(!$("#farmname").is(':checked')){
           // $("#farmname").find("option").remove();
        //   }
         
        }
        
            // $("#farmname .filter-option").text(res.data.farm_name)
            // $("select[name=farmname]").val(res.data.farm_id);
            // $("select[name=speciesEditStatus]").val(res.data.status)
            $("#farmname").multiselect('refresh');  // refresh the selectpicker with fetched courses
          }, 1000);*/
        //$('#farmname ').multiselect('select',res.data.farm_name)
        $("#speciesEditName").val(res.data.name)
        $("#speciesEditId").val(res.data.speciesID)
        $("select[name=speciesEditStatus]").val(res.data.status)
//        $( "#speciesEditId option:selected" ).text();
$('.selectpicker').selectpicker('refresh');
//$("#speciesEditId .filter-option").text(res.data.speciesID)
$("#speciesEditStatus .filter-option").text(res.data.status)
       // $("#speciesEditFamName option:selected").val(res.data.family_name)
        if(res.data.status === 1){
          $("#speciesEditStatus option:selected").text('Active')        
        }if(res.data.status === 0) {
          $("#speciesEditStatus option:selected").text('Inactive')
        }

//agegroup edit

setTimeout(() => {
  

     $("#agegroupName1").val(this.arrayval[0].tnag_name)
     $("#lowerlimit1").val(this.arrayval[0].lowerlimit)
     this.tnagid1=this.arrayval[0].tnag_id
     $("#upperlimit1").val(this.arrayval[0].upperlimit)
     $("#agegroupName2").val(this.arrayval[1].tnag_name)
     $("#lowerlimit2").val(this.arrayval[1].lowerlimit)
     this.tnagid2= this.arrayval[1].tnag_id
     $("#upperlimit2").val(this.arrayval[1].upperlimit)
     $("#agegroupName3").val(this.arrayval[2].tnag_name)
     $("#lowerlimit3").val(this.arrayval[2].lowerlimit)
     this.tnagid3= this.arrayval[2].tnag_id
     $("#upperlimit3").val(this.arrayval[2].upperlimit)
     $("#agegroupName4").val(this.arrayval[3].tnag_name)
     $("#lowerlimit4").val(this.arrayval[3].lowerlimit)
     this.tnagid4= this.arrayval[3].tnag_id
     $("#upperlimit4").val(this.arrayval[3].upperlimit)
    }, 100);
      })


  }
  editstatusvalue(){
    $('.speciesfak').dropdown('toggle');
  }
  modelpopupgetdata(){
    this.age_group_getval=[]
    /*var values = $('input[name="Name"]').map(function(){
      return this.value;
   }).get();*/
   
  // console.log(values);
   var arraydummya =[];
   for(var i=0;i<this.arrayval.length;i++){
var obj = {
 name: $("#Name_"+this.arrayval[i].tnag_id).val(),
 time_range: $("#timerange_"+this.arrayval[i].tnag_id).val(),
};
    arraydummya.push(obj);
   }
   console.log(arraydummya);

   
   var gettimerange="";
   for(var i=0;i<arraydummya.length;i++){
    var beverage = (gettimerange == "") ? "0" :parseInt(gettimerange) + parseInt("1");
    console.log(beverage); 
     var initialvalue=beverage
    gettimerange=arraydummya[i].time_range;
    console.log(initialvalue+"_"+gettimerange)
   var resultrange=initialvalue+"-"+gettimerange;
    var obj1 = {
    name:arraydummya[i].name ,
     time_range:resultrange,
     status:arraydummya[i].status 
     };
     this.age_group_getval.push(obj1)
  }
  console.log(this.age_group_getval)
  }

  getinputvalue(e){
    console.log(e.target.value)
   var value1 =parseInt("1")+parseInt(e.target.value);
    this.upperlimit= isNaN(value1) ? '' : value1;
  }
  getinputvalue2(e){
    console.log(e.target.value)
   var value1 =parseInt("1")+parseInt(e.target.value);
    this.upperlimit1= isNaN(value1) ? '' : value1;
    //this.hiben=isNaN(value1) ? '' : 'NaN';
  }
  getinputvalue3(e){
    console.log(e.target.value)
   var value1 =parseInt("1")+parseInt(e.target.value);
    this.upperlimit2= isNaN(value1) ? '' : value1;
  }
  createagegrouprow(){
    this.isDone = 1;
    this.isDisabled = true;
  console.log("work")
  }
  async speciesmanagement(){
    var finalvalue=[];
    var agegroupName1=$("#agegroupName1").val();
    var agegroup1limit=$("#lowerlimit1").val()+'-'+$("#upperlimit1").val();
    var agegroup1object={name:agegroupName1,time_range:agegroup1limit,id:this.tnagid1}
    finalvalue.push(agegroup1object);
    var agegroupName2=$("#agegroupName2").val();
    var secup=$("#upperlimit2").val()
    var secondupperlimit=(secup)?secup:'n';
    var agegroup2limit=$("#lowerlimit2").val()+'-'+secondupperlimit;
    if(agegroupName2){
    var agegroup2object={name:agegroupName2,time_range:agegroup2limit,id:this.tnagid2}
    finalvalue.push(agegroup2object);
    }
    var agegroupName3=$("#agegroupName3").val();
    var thirdup=$("#upperlimit3").val()
    var thirdupperlimit=(thirdup)?thirdup:'n';
    var agegroup3limit=$("#lowerlimit3").val()+'-'+thirdupperlimit;
    if(agegroupName3){
    var agegroup3object={name:agegroupName3,time_range:agegroup3limit,id:this.tnagid3}
    finalvalue.push(agegroup3object);
  }
    var agegroupName4=$("#agegroupName4").val();
    var fourthup=$("#upperlimit4").val()
    var fourthupperlimit=(fourthup)?fourthup:'n';
    var agegroup4limit=$("#lowerlimit4").val()+'-'+fourthupperlimit;
    if(agegroupName4!=undefined){
    var agegroup4object={name:agegroupName4,time_range:agegroup4limit,id:this.tnagid4}
    finalvalue.push(agegroup4object);
  }
console.log(finalvalue);
   var myarray= $("#farmname").val().toString()
   console.log(myarray)
    this.editSpeciesFormValue = {
      "age_group":finalvalue,
      "name": $("#speciesEditName").val(),
      "speciesID":$("#speciesEditId").val(),
      "farm_id":myarray,
      "status":$("#speciesEditStatus").val(),
      "family_name":"species record 40  family",
      "mby":this.cby_mby,
      "cby":this.cby_mby,
      "is_active":1
  };
    (await this.commonService.putApi( this.putspecieseditApi,this.editSpeciesFormValue)).subscribe(
      data => {
          alert("Data edited Successfully");
      });
      setTimeout(
        () : void => {

          this.router.navigate([this.returnUrl]);

        },
        500
      );
  }
  openmodelpopup(){
    $('.selectpicker').selectpicker('refresh');
    $("#myModal").modal("toggle");
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
